import { z } from "zod"

export const ApiJsonObjectSchema = z.record(z.string(), z.unknown())
export const ApiSlugSchema = z
  .string()
  .min(2)
  .max(80)
  .regex(/^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/)

export const ApiErrorResponseSchema = z.object({
  error: z.object({
    code: z.string(),
    message: z.string(),
    requestId: z.string(),
  }),
})

export type ApiErrorResponse = z.infer<typeof ApiErrorResponseSchema>

export const ApiPaginationQuerySchema = z.object({
  limit: z.number().int().min(1).max(100).default(50),
  offset: z.number().int().min(0).default(0),
})

export type ApiPaginationQuery = z.infer<typeof ApiPaginationQuerySchema>
